import { render, staticRenderFns } from "./downAgent.vue?vue&type=template&id=5544012f&scoped=true&"
import script from "./downAgent.vue?vue&type=script&lang=js&"
export * from "./downAgent.vue?vue&type=script&lang=js&"
import style0 from "./downAgent.vue?vue&type=style&index=0&id=5544012f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5544012f",
  null
  
)

export default component.exports